import axios from "./axios";

export async function fetchSigningRequests(params = {}) {
  return axios.get("/signing/requests", { params }).then((response) => response.data);
}

export async function createSigningRequest(payload) {
  return axios
    .post("/signing/requests", { signing_request: payload })
    .then((response) => response.data);
}

export async function createServiceAgreementSigningRequest(agreementId, payload) {
  return axios
    .post(`/service/agreements/${agreementId}/signing_requests`, {
      signing_request: payload,
    })
    .then((response) => response.data);
}

export async function createEmployeeSigningRequest(userId, employeeId, payload) {
  return axios
    .post(`/users/${userId}/employees/${employeeId}/signing_requests`, {
      signing_request: payload,
    })
    .then((response) => response.data);
}

export async function pollSigningRequest(id) {
  return axios.post(`/signing/requests/${id}/poll`).then((response) => response.data);
}

export async function downloadSignedDocument(id) {
  return axios.get(`/signing/requests/${id}/signed_document`, {
    responseType: "blob",
  });
}
